module.exports = __webpack_public_path__ + "static/media/payment-support-banks.bbbf576a.svg";